import React from 'react';
import PropTypes from 'prop-types';

import Hero from 'components/Hero';
import { CHILDREN_PROP_TYPES } from 'propTypes/childrenPropTypes';

function DefaultScreenHero({ heroImage, heroContent }) {
  return <Hero image={heroImage}>{heroContent}</Hero>;
}

DefaultScreenHero.propTypes = {
  heroImage: PropTypes.object,
  heroContent: CHILDREN_PROP_TYPES
};

export default DefaultScreenHero;
